import { ModuleWithProviders, NgModule } from '@angular/core';
import { RxExternalCatalog } from './services/shared/rx-external-catalog.service';
import { ExternalCatalogLoader } from './services/shared/external-catalog-loader.service';
import { SecoWindowService } from './services/shared/seco-window.service';
import { DIRECTIVES } from './directives/index';
import { SecoPilotingConfig, SecoPilotingConfigType } from './seco-piloting-config';

export * from './directives/index';

const defaultConfig: SecoPilotingConfigType = {
  loginUrl:
    'https://ncebpm0720aph01.etv.nce.amadeus.net/LoginService/login.jsp?SITE=LOGINURL&OV_SITE_SMART_PORTAL_URL=',
  externalCatalogUrl: 'https://ncebpm0720aph01.etv.nce.amadeus.net/ExternalCatalog.js',
  language: 'GB'
};

export const defaultSecoPilotingConfig = new SecoPilotingConfig(defaultConfig);

@NgModule({
  declarations: [DIRECTIVES],
  providers: [
    { provide: 'SMARTSCRIPT_WINDOW', useValue: window },
    { provide: SecoPilotingConfig, useValue: defaultSecoPilotingConfig },
    RxExternalCatalog,
    ExternalCatalogLoader
  ],
  exports: [DIRECTIVES]
})
export class SecoPilotingModule {
  // inject to make sure SecoWindowService is instantiated and click interception set up.
  constructor(secoWindow: SecoWindowService) {
    secoWindow.init();
  }

  static forRoot(config: SecoPilotingConfigType): ModuleWithProviders<SecoPilotingModule> {
    const secoPilotingConfig = new SecoPilotingConfig(config);
    return {
      ngModule: SecoPilotingModule,
      providers: [
        {
          provide: SecoPilotingConfig,
          useValue: secoPilotingConfig
        },
        RxExternalCatalog,
        ExternalCatalogLoader
      ]
    };
  }
}
